export const Experiments = {
  b2c_041_fundraising_page_donation_prompts_2:
    'b2c_041_fundraising_page_donation_prompts_2',
  b2c_045_donate_button_color: 'b2c_045_donate_button_color',
  b2c_029_first_to_donate: 'b2c_029_first_to_donate',
  b2c_040_frp_trust_proposition_bar: 'b2c_040_frp_trust_proposition_bar',
  b2c_044_donate_to_yourself: 'b2c_044_donate_to_yourself',
  starting_donation_on_frp_with_amount_page_mobile:
    'starting_donation_on_frp_with_amount_page_mobile',
  starting_donation_on_frp_with_amount_page_desktop:
    'starting_donation_on_frp_with_amount_page_desktop',
  b2c_048_show_hide_fitness_data: 'b2c_048_show_hide_fitness_data',
};
